import { combineReducers } from 'redux';

import containerReducer from './ducks/container';

const reducers = {
  container: containerReducer,
};

export default combineReducers(reducers);
